<template>
  <div class="container">
    <div class="row">
      <div class="col s12" style="margin-top: 1vh;">
        <div class="col s4">
          <button
            @click="supply.materials--"
            class="waves-effect waves-light btn col s12"
          >
            -
          </button>
        </div>
        <div class="col s4">{{ supply.materials }} Materials</div>
        <div class="col s4">
          <button
            @click="supply.materials++"
            class="waves-effect waves-light btn col s12"
          >
            +
          </button>
        </div>
      </div>

      <div class="col s12" style="margin-top: 1vh;">
        <div class="col s4">
          <button
            @click="supply.population--"
            class="waves-effect waves-light btn col s12"
          >
            -
          </button>
        </div>
        <div class="col s4">{{ supply.population }} Population</div>
        <div class="col s4">
          <button
            @click="supply.population++"
            class="waves-effect waves-light btn col s12"
          >
            +
          </button>
        </div>
      </div>

      <div class="col s12" style="margin-top: 1vh;">
        <div class="col s4">
          <button
            @click="supply.progress--"
            class="waves-effect waves-light btn col s12"
          >
            -
          </button>
        </div>
        <div class="col s4">{{ supply.progress }} Progress</div>
        <div class="col s4">
          <button
            @click="supply.progress++"
            class="waves-effect waves-light btn col s12"
          >
            +
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    playerOrBot: Object,
  },
  setup(props) {
    console.log(props);
    return {
      supply: props.playerOrBot,
    };
  },
});
</script>

<style></style>
